import { isNil } from 'lodash/fp';
import { createAction, lt, showSuccessAlert } from '@mews/framework';
import { RouteName } from '@mews-commander/enums';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { openModal } from '../../app/actions/common';
import { getGeneratedExportData } from '../selectors/export';
import { JSON_DOWNLOAD_STARTED, IMPORT_SCHEDULE } from './types';

export const startJSONDownload = () => createAction(JSON_DOWNLOAD_STARTED, undefined);

export const scheduleImport =
    (data: ReturnType<typeof getGeneratedExportData>): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container, resolveRoute }) => {
        const url = resolveRoute(RouteName.ImportQueueItemIndex);

        const promise = container()
            .importComponent.schedule({ data })
            .then(({ queueItemId }: { queueItemId?: string }) => {
                if (!isNil(queueItemId)) {
                    dispatch(openModal(url));
                    showSuccessAlert({ description: lt('ImportStartedSuccessMessage') });
                }
            });

        return dispatch(createFetchAction(IMPORT_SCHEDULE, promise));
    };
